import type { CameraRoute } from '@datum-sdk/scene-format';

/**
 * The Mina preloader flights, as SDK scene data: the tour, then a flyover of
 * three views through the tent city that settles on the rest pose — its last
 * view, where the eye level then stays for the session.
 *
 * Converted once from the legacy `minaSceneConfig.camera` by
 * `convertLegacyPreloader.ts` (which says what in here is load-bearing); the
 * routes are the source since. Tune them in the SDK editor (`?flight` → Routes →
 * Copy Routes) — the same workflow as `kaabaRoutes.ts` — and
 * `sceneRoutes.test.ts` holds them to what the preloader and the scene need.
 *
 * The middle view looks at a different point than the other two, so the aim
 * rides its own curve. The tour rings outside the camera cage, so the
 * preloader lifts collisions for its routes (`createSdkScene.ts`); the scene
 * is first-person, and each route hands the camera back to FPS when it lands.
 */
export const MINA_CAMERA_ROUTES: CameraRoute[] = [
  {
    id: 'preview-enter',
    waypoints: [
      {
        target: [-2.34, 0.79, 1.84],
        lookAt: [-2.43, -1.54, -4.25],
        duration: 1500,
        easing: [0.65, 0, 0.35, 1],
      },
      {
        orbit: {
          radius: 6.521127203,
          azimuth: 1.739278649,
          polar: 1.205420657,
        },
        target: [-2.43, -1.54, -4.25],
        lookAt: 'target',
        duration: 500,
        easing: [0.333333333, 0, 0.666666667, 0.333333333],
      },
    ],
  },
  {
    id: 'preview-turntable',
    loop: true,
    waypoints: [
      {
        orbit: {
          radius: 6.521127203,
          azimuth: 3.310074976,
          polar: 1.205420657,
        },
        target: [-2.43, -1.54, -4.25],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.521127203,
          azimuth: 4.880871302,
          polar: 1.205420657,
        },
        target: [-2.43, -1.54, -4.25],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.521127203,
          azimuth: 6.451667629,
          polar: 1.205420657,
        },
        target: [-2.43, -1.54, -4.25],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.521127203,
          azimuth: 8.022463956,
          polar: 1.205420657,
        },
        target: [-2.43, -1.54, -4.25],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
    ],
  },
  {
    id: 'preview-exit',
    waypoints: [
      {
        target: [2.35, 0.38, -1.74],
        lookAt: [-2.43, -1.54, -4.25],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
    ],
  },
  {
    id: 'preloader-flyover',
    waypoints: [
      {
        duration: 1000,
      },
      {
        kind: 'view',
        position: [-0.055, -1.337, -4.027],
        lookAt: [-2.43, -1.54, -4.25],
        duration: 3000,
        easing: [0.333333333, 0, 0.666666667, 0.638711371],
      },
      {
        kind: 'view',
        position: [-3.113, -1.232, -1.112],
        lookAt: [-4.127, -1.503, -1.972],
        duration: 3000,
        easing: [0.333333333, 0.309572177, 0.666666667, 0.489045591],
      },
      {
        kind: 'view',
        position: [2.577, 0.632, 2.12],
        lookAt: [-2.43, -1.54, -4.25],
        duration: 2000,
        easing: [0.333333333, 0.219071225, 0.666666667, 1],
      },
    ],
  },
];
